<template>
  <div>
    <div
      class="modal fade"
      id="editWaveDialog"
      data-backdrop="static"
      data-keyboard="false"
    >
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <!-- Close button in the upper right corner -->
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-hidden="true"
            >
              ×
            </button>

            <!-- Modal Title -->
            <h4 class="modal-title">
              <b>{{ lang.WV0000 }}</b>
            </h4>
            <p>
              <b>{{ lang.WV0024 }}:</b>
              {{ selectedProjectData.ProjectId }} -
              {{ selectedProjectData.ProjectName }},
              <b>{{ lang.WV0025 }}:</b>
              {{ selectedProjectData.ClientId }} -
              {{ selectedProjectData.ClientName }}
            </p>
          </div>
          <div class="modal-body">
            <div class="panel panel-default">
              <div class="panel-body">
                <div class="col-md-6" style="padding-left: 0">
                  <!-- Searchbar - triggered by enter key -->
                  <div
                    class="form-group searchbar col-md-6"
                    style="padding-left: 15px"
                  >
                    <input
                      type="search"
                      class="form-control"
                      id="editwave-modal-inputSearch"
                      :placeholder="lang.WV0001"
                      v-model="filterWaveString"
                      @input="doFilteringWaves()"
                    />
                  </div>
                  <div
                    class="form-group searchbar col-md-6"
                    style="padding-left: 15px"
                  >
                    <button
                      type="button"
                      class="btn btn-raised btn-default"
                      :class="{ 'btn-warning': wavePositionsDirty }"
                      @click="saveWavePositions()"
                    >
                      {{ lang.WV0026 }}
                    </button>
                  </div>
                  <!-- Wave table -->
                  <div class="table-container table-waves" style="clear: both">
                    <table
                      class="table table-striped table-hover"
                      id="wavesTable"
                    >
                      <thead>
                        <tr>
                          <th class="text-center" style="width: 10%">
                            {{ lang.WV0002 }}
                          </th>
                          <th class="text-center" style="width: 40%">
                            {{ lang.WV0003 }}
                          </th>
                          <th class="text-center" style="width: 20%">
                            {{ lang.WV0004 }}
                          </th>
                          <th class="text-center" style="width: 20%">
                            {{ lang.WV0005 }}
                          </th>
                          <th class="text-center" style="width: 10%">
                            {{ lang.WV0027 }}
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          role="button"
                          :key="wave.WaveGuid"
                          @click="selectWave(wave.WaveGuid)"
                          :class="{ info: isWaveSelected(wave.WaveGuid) }"
                          v-for="wave in filteredWaves"
                        >
                          <td>{{ wave.WaveId }}</td>
                          <td>{{ wave.WaveName }}</td>
                          <td>
                            {{
                              globals.getLocalizedDateFromIsoTimestamp(
                                wave.WaveSince
                              )
                            }}
                          </td>
                          <td>
                            {{
                              globals.getLocalizedDateFromIsoTimestamp(
                                wave.WaveUntil
                              )
                            }}
                          </td>
                          <td class="nopadding">
                            <div class="form-group nopadding">
                              <select
                                class="form-control text-center nopadding"
                                v-model="wave.WavePosition"
                                @change="
                                  reorderWaves(), (wavePositionsDirty = true)
                                "
                                @click.stop
                              >
                                <option
                                  v-for="w in waves"
                                  :key="w.WavePosition"
                                  :value="w.WavePosition"
                                >
                                  {{ w.WavePosition }}
                                </option>
                              </select>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div class="col-md-6" style="padding-right: 0">
                  <ul
                    class="nav nav-tabs nav-wave-edit"
                    style="margin-bottom: 15px"
                  >
                    <li class="active">
                      <a
                        href="#editWaveTab"
                        id="project-management-wave-edit-add-wave-tab"
                        data-toggle="tab"
                        @click="selectedTab = 'editWaveTab'"
                        >{{ lang.WV0006 }}</a
                      >
                    </li>
                    <li>
                      <a
                        href="#assignScenariosTab"
                        id="project-management-wave-edit-assign-scenarios-tab"
                        data-toggle="tab"
                        @click="selectedTab = 'assignScenariosTab'"
                        >{{ lang.WV0007 }}</a
                      >
                    </li>
                    <li>
                      <a
                        href="#carModelDistributionTab"
                        data-toggle="tab"
                        v-if="carModelList.length > 0"
                        @click="selectedTab = 'carModelDistributionTab'"
                        >{{ lang.WV0029 }}</a
                      >
                    </li>
                    <li>
                      <a
                        href="#competitorCarModelDistributionTab"
                        data-toggle="tab"
                        v-if="
                          feature.isAudiTarget &&
                          feature.isEnabled('shopperApproval')
                        "
                        @click="
                          selectedTab = 'competitorCarModelDistributionTab'
                        "
                        >{{ lang.WV0035 }}</a
                      >
                    </li>
                  </ul>

                  <div class="tab-content">
                    <div class="tab-pane fade active in" id="editWaveTab">
                      <div class="form-group">
                        <label
                          for="inputWaveName"
                          class="col-md-3 control-label"
                          >{{ lang.WV0003 }}</label
                        >
                        <div class="col-md-9">
                          <input
                            type="text"
                            class="form-control"
                            id="inputWaveName"
                            @input="selectedWaveDirty = true"
                            v-model="selectedWave.WaveName"
                          />
                        </div>
                      </div>
                      <div class="form-group">
                        <label
                          for="inputShortWaveName"
                          class="col-md-3 control-label"
                          >{{ lang.WV0039 }}</label
                        >
                        <div class="col-md-9">
                          <input
                            type="text"
                            class="form-control"
                            id="inputShortWaveName"
                            @input="selectedWaveDirty = true"
                            v-model="selectedWave.ShortWaveName"
                            maxlength="19"
                          />
                        </div>
                      </div>
                      <div class="form-group">
                        <label
                          for="inputWaveStartDate"
                          class="col-md-3 control-label"
                          >{{ lang.WV0004 }}</label
                        >
                        <div
                          id="inputWaveStartDateFlatpickr"
                          class="col-md-9"
                          @click="globals.toggleFlatpickr('inputWaveStartDate')"
                        >
                          <input
                            type="text"
                            class="form-control"
                            id="inputWaveStartDate"
                            @input="selectedWaveDirty = true"
                            v-model="selectedWave.WaveSince"
                          />
                        </div>
                      </div>
                      <div class="form-group">
                        <label
                          for="inputWaveEndDate"
                          class="col-md-3 control-label"
                          >{{ lang.WV0005 }}</label
                        >
                        <div
                          class="col-md-9"
                          @click="globals.toggleFlatpickr('inputWaveEndDate')"
                        >
                          <input
                            type="text"
                            class="form-control"
                            id="inputWaveEndDate"
                            @input="selectedWaveDirty = true"
                            v-model="selectedWave.WaveUntil"
                          />
                        </div>
                      </div>
                      <div class="form-group" v-if="!feature.isAudiTarget">
                        <label
                          for="inputWaveEditCostCenter"
                          class="col-md-3 control-label"
                          >{{ lang.WV0028 }}</label
                        >
                        <div class="col-md-9">
                          <input
                            type="text"
                            class="form-control"
                            id="inputWaveEditCostCenter"
                            @input="selectedWaveDirty = true"
                            v-model="selectedWave.CostCenter"
                          />
                        </div>
                      </div>
                      <div class="form-group">
                        <label
                          for="inputWaveEditWaveInfo"
                          class="col-md-3 control-label"
                          >{{ lang.WV0033 }}</label
                        >
                        <div class="col-md-9">
                          <textarea
                            type="text"
                            class="form-control"
                            id="inputWaveEditWaveInfo"
                            maxlength="500"
                            rows="4"
                            @input="selectedWaveDirty = true"
                            v-model="selectedWave.WaveInfo"
                          />
                        </div>
                      </div>
                      <div class="form-group" v-if="feature.isPorscheTarget">
                        <label
                          for="inputWaveEditCostCenter"
                          class="col-md-3 control-label"
                          >Select master survey</label
                        >
                        <div class="col-md-9">
                          <select2
                            id="wave-editmodal-masterwave-select"
                            class="inputMasterSurveyForWave col-md-10"
                            name="inputMasterSurveyForWave"
                            instanceId="inputMasterSurveyForWave"
                            placeholder="No survey selected"
                            v-model="selectedWave.MasterSurvey"
                            :key="selectedWave.MasterSurvey"
                            :allowClear="true"
                          >
                            <option
                              v-for="survey in surveyList"
                              :key="survey.SurveyId"
                              :value="survey.SurveyId"
                              :disabled="survey.disabled"
                            >
                              (SID:{{ survey.SurveyId }})
                              {{ survey.SurveyTitle }}
                            </option>
                          </select2>
                        </div>
                      </div>
                      <div class="form-group">
                        <label
                          for="inputWaveReportingVisibility"
                          class="col-md-3 control-label"
                          >{{ lang.WV0008 }}</label
                        >
                        <div
                          class="checkbox"
                          style="float: left; margin-left: 15px"
                        >
                          <label>
                            <input
                              type="checkbox"
                              id="inputWaveReportingVisibility"
                              @input="selectedWaveDirty = true"
                              @change="
                                waveReportingVisibilityChanged(selectedWave)
                              "
                              v-model="selectedWave.ReportingVisibility"
                            />
                            <span class="checkbox-material">
                              <span class="check"></span>
                            </span>
                          </label>
                        </div>
                      </div>
                      <button
                        type="button"
                        class="btn btn-raised btn-top-bar"
                        @click="createNewWave()"
                        :disabled="!selectedWave.WaveName"
                      >
                        <i class="material-icons md-36">add_box</i>
                        <br />
                        {{ lang.WV0009 }}
                      </button>
                      <button
                        id="project-management-wave-save"
                        type="button"
                        class="btn btn-raised btn-success btn-top-bar"
                        @click="saveSelectedWave()"
                        :class="{ 'btn-warning': selectedWaveDirty }"
                        :disabled="
                          !selectedWave.WaveName ||
                          !selectedWave.WaveSince ||
                          !selectedWave.WaveUntil ||
                          (!globals.isAccessAllowed(
                            'LoopOp_ProjectWaves_Create'
                          ) &&
                            !selectedWave.WaveId) ||
                          (!globals.isAccessAllowed(
                            'LoopOp_ProjectWaves_Update'
                          ) &&
                            selectedWave.WaveId)
                        "
                      >
                        <i class="material-icons md-36">save</i>
                        <br />
                        {{ lang.WV0010 }}
                      </button>
                      <button
                        type="button"
                        class="btn btn-raised btn-top-bar"
                        @click="openDeleteWaveConfirmationDialog()"
                        :disabled="
                          !selectedWave.WaveId ||
                          !globals.isAccessAllowed('LoopOp_ProjectWaves_Delete')
                        "
                      >
                        <i class="material-icons md-36">delete</i>
                        <br />
                        {{ lang.WV0011 }}
                      </button>
                      <button
                        type="button"
                        class="btn btn-raised btn-top-bar"
                        @click="showWaveStatus()"
                        :disabled="!selectedWave.WaveId"
                      >
                        <i class="material-icons md-36">insert_chart</i>
                        <br />
                        {{ lang.WV0034 }}
                      </button>
                    </div>

                    <div class="tab-pane fade" id="assignScenariosTab">
                      <!-- Searchbar - triggered by enter key -->
                      <div
                        class="form-group searchbar"
                        style="margin-right: 15px"
                      >
                        <input
                          type="search"
                          class="form-control"
                          style="max-width: 40%; display: inline; float: left"
                          :placeholder="lang.WV0001"
                          v-model="filterScenarioString"
                          @input="doFilteringScenarios()"
                        />
                        <button
                          id="saveAssignment"
                          type="button"
                          class="btn btn-raised btn-success"
                          style="float: right"
                          :class="{ 'btn-warning': selectedWaveDirty }"
                          @click="saveSelectedWave()"
                          :disabled="
                            !selectedWave.WaveName ||
                            !selectedWave.WaveSince ||
                            !selectedWave.WaveUntil ||
                            (!globals.isAccessAllowed(
                              'LoopOp_ProjectWaves_Create'
                            ) &&
                              !selectedWave.WaveId) ||
                            (!globals.isAccessAllowed(
                              'LoopOp_ProjectWaves_Update'
                            ) &&
                              selectedWave.WaveId)
                          "
                        >
                          {{ lang.WV0010 }}
                        </button>
                      </div>
                      <!-- Scenario table -->
                      <div class="table-container">
                        <table
                          class="table table-striped table-hover"
                          id="scenarioTable"
                        >
                          <thead>
                            <tr>
                              <th class="text-center" style="width: 10%">
                                {{ lang.WV0012 }}
                              </th>
                              <th class="text-center" style="width: 30%">
                                {{ lang.WV0013 }}
                              </th>
                              <th class="text-center" style="width: 60%">
                                {{ lang.WV0014 }}
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              role="button"
                              :key="scenario.ScenarioGuid"
                              @click="selectScenario(scenario.ScenarioGuid)"
                              :class="{
                                info: isScenarioSelected(scenario.ScenarioGuid),
                                'cursor-not-allowed': !selectedWave.WaveId,
                              }"
                              v-for="scenario in filteredScenarios"
                            >
                              <td style="width: 10%">
                                {{ scenario.ScenarioId }}
                              </td>
                              <td style="width: 30%">
                                {{ scenario.ScenarioName }}
                              </td>
                              <td style="width: 60%">
                                {{ scenario.ScenarioDescription }}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>

                    <div
                      class="tab-pane fade"
                      id="carModelDistributionTab"
                      v-if="carModelList.length > 0"
                    >
                      <div class="table-container">
                        <table class="table table-striped table-hover">
                          <thead>
                            <tr>
                              <th class="text-center" style="width: 50%">
                                {{ lang.WV0030 }}
                              </th>
                              <th class="text-center" style="width: 50%">
                                {{ lang.WV0031 }} (%)
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              :key="model.CarModelGuid"
                              v-for="model in carModelList"
                            >
                              <td>{{ model.CarModelName }}</td>
                              <td class="nopadding">
                                <div class="form-group nopadding">
                                  <input
                                    type="number"
                                    min="0"
                                    max="100"
                                    class="form-control text-center nopadding"
                                    v-model.number="model.Distribution"
                                    @change="
                                      (selectedWaveDirty = true),
                                        validateDistributionValue(model, 'audi')
                                    "
                                  />
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <button
                        type="button"
                        class="btn btn-raised btn-success"
                        style="float: right; margin-right: 20px"
                        :class="{ 'btn-warning': selectedWaveDirty }"
                        @click="saveSelectedWave()"
                        :disabled="
                          !selectedWave.WaveName ||
                          !selectedWave.WaveSince ||
                          !selectedWave.WaveUntil ||
                          (!globals.isAccessAllowed(
                            'LoopOp_ProjectWaves_Create'
                          ) &&
                            !selectedWave.WaveId) ||
                          (!globals.isAccessAllowed(
                            'LoopOp_ProjectWaves_Update'
                          ) &&
                            selectedWave.WaveId)
                        "
                      >
                        {{ lang.WV0010 }}
                      </button>
                    </div>

                    <div
                      class="tab-pane fade"
                      id="competitorCarModelDistributionTab"
                      v-if="
                        feature.isAudiTarget &&
                        feature.isEnabled('shopperApproval')
                      "
                    >
                      <div class="table-container">
                        <table class="table table-striped table-hover">
                          <thead>
                            <tr>
                              <th class="text-center" style="width: 50%">
                                {{ lang.WV0030 }}
                              </th>
                              <th class="text-center" style="width: 40%">
                                {{ lang.WV0031 }} (%)
                              </th>
                              <th class="text-center" style="width: 10%">
                                {{ lang.WV0036 }}
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              v-for="(
                                model, index
                              ) in selectedWave.CompetitorCarModelDistribution"
                              :key="index"
                            >
                              <td class="nopadding">
                                <div class="form-group nopadding">
                                  <input
                                    type="text"
                                    maxlength="200"
                                    class="form-control text-center nopadding"
                                    v-model.number="model.CompetitorCarModel"
                                    @change="selectedWaveDirty = true"
                                  />
                                </div>
                              </td>
                              <td class="nopadding">
                                <div class="form-group nopadding">
                                  <input
                                    type="number"
                                    min="0"
                                    max="100"
                                    class="form-control text-center nopadding"
                                    :value="(model.Distribution || 0) * 100"
                                    @change="
                                      (model.Distribution =
                                        ($event.target.value || 0) / 100),
                                        (selectedWaveDirty = true),
                                        validateDistributionValue(
                                          model,
                                          'competitor'
                                        )
                                    "
                                  />
                                </div>
                              </td>
                              <td>
                                <button
                                  class="btn nopadding"
                                  @click="deleteCompetitorCarModel(index)"
                                >
                                  <i class="material-icons md-24 text-red"
                                    >clear</i
                                  >
                                </button>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <button
                        type="button"
                        class="btn btn-raised"
                        style="float: left; margin-left: 20px"
                        @click="addCompetitorCarModel()"
                        :disabled="!selectedWave.WaveName"
                      >
                        {{ lang.WV0037 }}
                      </button>
                      <button
                        type="button"
                        class="btn btn-raised btn-success"
                        style="float: right; margin-right: 20px"
                        :class="{ 'btn-warning': selectedWaveDirty }"
                        @click="saveSelectedWave()"
                        :disabled="
                          !selectedWave.WaveName ||
                          !selectedWave.WaveSince ||
                          !selectedWave.WaveUntil ||
                          (!globals.isAccessAllowed(
                            'LoopOp_ProjectWaves_Create'
                          ) &&
                            !selectedWave.WaveId) ||
                          (!globals.isAccessAllowed(
                            'LoopOp_ProjectWaves_Update'
                          ) &&
                            selectedWave.WaveId)
                        "
                      >
                        {{ lang.WV0010 }}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <!-- Add modal buttons here -->
            <button
              type="button"
              class="btn btn-raised btn-default"
              data-dismiss="modal"
            >
              {{ lang.WV0015 }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <WaveStatusModal></WaveStatusModal>
  </div>
</template>

<script>
import WaveStatusModal from "./WaveStatusModal";
import UseSurvey from "../../services/Surveys";
import Select2 from "../Tools/Select2";
const uuidv4 = require("uuid/v4");

export default {
  name: "WaveEditDialog",
  components: { Select2, WaveStatusModal },
  props: ["showDialog", "selectedClient", "selectedProjectData"],
  mounted() {
    if (this.globals.selectedLanguage) {
      this.globals.getLanguageStrings(this);
      this.initFlatpickr();
    }

    $("#editWaveDialog").on("hidden.bs.modal", (e) => {
      this.$emit("dialogClosed");
    });

    // Register global events
    this.globals.$off("WaveDeleteModalYesConfirmation");
    this.globals.$on("WaveDeleteModalYesConfirmation", () => {
      this.deleteSelectedWave();
    });

    if (this.feature.isAudiTarget && this.feature.isEnabled("shopperApproval"))
      this.globals.getCarModelList((data) => {
        this.carModelList = _.cloneDeep(data);
      });
  },
  destroyed() {
    if (this.fpInputWaveUntil) this.fpInputWaveUntil.destroy();
    if (this.fpInputWaveSince) this.fpInputWaveSince.destroy();
  },
  watch: {
    showDialog() {
      if (this.showDialog) this.openWaveEditDialog();
      else this.closeWaveEditDialog();
    },
    "globals.selectedLanguage"() {
      this.globals.getLanguageStrings(this);
      this.initFlatpickr();
    },
  },
  data() {
    return {
      waves: [],
      wavePositions: [],
      scenarios: [],
      filteredWaves: [],
      filteredScenarios: [],
      carModelList: [],
      filterWaveString: "",
      filterScenarioString: "",
      selectedTab: "editWaveTab",
      selectedWave: {},
      selectedWaveDirty: false,
      wavePositionsDirty: false,
      scenariosOfClient: [],
      fpInputWaveUntil: null,
      fpInputWaveSince: null,
      forceReportingVisibilityChange: false,
      surveyList: [],
      lang: {
        WV0000: "Wave Administration",
        WV0001: "Filter",
        WV0002: "ID",
        WV0003: "Name",
        WV0004: "Start date",
        WV0005: "End date",
        WV0006: "Edit wave",
        WV0007: "Assign scenarios",
        WV0008: "Reporting Visibility",
        WV0009: "New",
        WV0010: "Save",
        WV0011: "Delete",
        WV0012: "ID",
        WV0013: "Name",
        WV0014: "Description",
        WV0015: "Close",
        WV0016: "Yes",
        WV0017: "No",
        WV0018: "Delete Wave",
        WV0019: "Do you really want to delete the following wave?",
        WV0020: "Period of time",
        WV0021: "Change Reporting Visibility",
        WV0022:
          "Do you really want to make the whole wave visible in reporting?",
        WV0023:
          "All defined security settings on user level for this wave will be lost.",
        WV0024: "Project",
        WV0025: "Client",
        WV0026: "Save positions",
        WV0027: "Position",
        WV0028: "Cost center",
        WV0029: "Audi cars",
        WV0030: "Model",
        WV0031: "Share",
        WV0032: "Overall share values exceed 100%",
        WV0033: "Info",
        WV0034: "Status",
        WV0035: "Competitor Cars",
        WV0036: "Actions",
        WV0037: "Add model",
        WV0038: "Empty model already exists",
        WV0039: "Shortname",
        WV0040: "No master survey",
      },
    };
  },
  methods: {
    // Initialize flatpickr instances
    initFlatpickr() {
      this.fpInputWaveSince = flatpickr(
        "#inputWaveStartDate",
        this.globals.flatpickrDateConfig
      );
      this.fpInputWaveUntil = flatpickr(
        "#inputWaveEndDate",
        this.globals.flatpickrDateConfig
      );
    },

    readCarModelDistributionFromSelectedWave() {
      this.clearCarModelDistribution();

      if (!this.selectedWave.CarModelDistribution) return;

      for (let waveEntry of this.selectedWave.CarModelDistribution) {
        let modelListEntry = _.find(
          this.carModelList,
          (model) => model.CarModelGuid === waveEntry.CarModelGuid
        );
        if (modelListEntry)
          modelListEntry.Distribution = waveEntry.Distribution * 100;
      }
    },

    storeCarModelDistributionToSelectedWave() {
      let sum = 0;
      this.selectedWave.CarModelDistribution = [];

      for (let entry of this.carModelList) {
        if (entry.Distribution) {
          sum += entry.Distribution;
          this.selectedWave.CarModelDistribution.push({
            CarModelGuid: entry.CarModelGuid,
            Distribution: entry.Distribution / 100,
          });
        }
      }

      if (this.selectedWave.CarModelDistribution.length < 1)
        delete this.selectedWave.CarModelDistribution;

      if (sum > 100) {
        this.globals.showErrorSnackbar(this.lang.WV0032);
        console.error(
          "Overall car model distribution values for this wave exceed 100%"
        );
        return false;
      }
      return true;
    },

    clearCarModelDistribution() {
      for (let entry of this.carModelList) delete entry.Distribution;
    },

    addCompetitorCarModel() {
      for (let entry of this.selectedWave.CompetitorCarModelDistribution)
        if (!entry.CompetitorCarModel) {
          this.globals.showErrorSnackbar(this.lang.WV0038);
          console.error("Empty competitor model already existis");
          return;
        }

      this.selectedWave.CompetitorCarModelDistribution.push({});
      this.$forceUpdate();
    },

    deleteCompetitorCarModel(index) {
      _.pullAt(this.selectedWave.CompetitorCarModelDistribution, index);
      this.$forceUpdate();
    },

    validateDistributionValue(model, type) {
      let lowerLimit = 0,
        upperLimit = 100;
      if (type === "competitor") upperLimit = 1;

      if (
        typeof model.Distribution !== "number" ||
        model.Distribution < lowerLimit
      )
        model.Distribution = lowerLimit;
      else if (model.Distribution > upperLimit) model.Distribution = upperLimit;

      this.$forceUpdate();
    },

    validateCompetitorCarModelDistribution() {
      if (this.selectedWave.CompetitorCarModelDistribution.length < 1) {
        delete this.selectedWave.CompetitorCarModelDistribution;
        return;
      }

      let sum = 0;
      for (let model of this.selectedWave.CompetitorCarModelDistribution)
        sum += model.Distribution || 0;

      if (sum > 1) {
        this.globals.showErrorSnackbar(this.lang.WV0032);
        console.error(
          "Overall competitor model distribution values for this wave exceed 100%"
        );
        return false;
      }
    },

    showWaveStatus() {
      let config = {
        guid: this.selectedWave.WaveGuid,
        id: this.selectedWave.WaveId,
      };
      this.globals.$emit("showWaveStatus", config);
    },

    saveSelectedWave() {
      if (
        this.carModelList.length > 0 &&
        !this.storeCarModelDistributionToSelectedWave()
      ) {
        return;
      }
      if (
        this.selectedWave.CompetitorCarModelDistribution &&
        this.validateCompetitorCarModelDistribution() === false
      ) {
        return;
      }
      if (isNaN(parseInt(this.selectedWave.MasterSurvey))) {
        this.selectedWave.MasterSurvey = null;
      }
      let data, queryString;
      let currentWaveIndex = _.findIndex(this.waves, (w) => {
        return w.WaveGuid === this.selectedWave.WaveGuid;
      });
      if (this.selectedWave.WaveSince >= this.selectedWave.WaveUntil) {
        this.globals.showErrorSnackbar("Start >= End");
        return;
      } else if (currentWaveIndex > -1) {
        // Wave does already exist
        queryString = `api/ProjectWaves/${this.selectedWave.WaveGuid}`;
        data = JSON.stringify(this.selectedWave);

        $.ajax({
          method: "PUT",
          url: queryString,
          data: data,
          dataType: "json",
          contentType: "application/json; charset=utf-8",
          success: (data) => {
            if (data.Error) {
              console.error(data.Error);
              this.globals.showErrorSnackbar(data.Error);
              return;
            }
            if (!this.selectedWave.CompetitorCarModelDistribution)
              this.selectedWave.CompetitorCarModelDistribution = [];
            if (!this.selectedWave.MasterSurvey) {
              this.selectedWave.MasterSurvey = null;
            }
            this.waves[currentWaveIndex] = _.cloneDeep(this.selectedWave);
            this.doFilteringWaves();
            this.$forceUpdate();
            this.globals.showSuccessSnackbar("Wave update successful");
            this.selectedWaveDirty = false;
          },
          error: () => {
            console.error("Error on PUT in saveSelectedWave()");
            this.globals.showErrorSnackbar("Wave update failed");
          },
        });
      } else {
        // Wave does not yet exist
        delete this.selectedWave.WaveId;
        this.selectedWave.WaveGuid = uuidv4();

        queryString = `api/Projects/${this.selectedProjectData.ProjectGuid}/Waves`;
        data = JSON.stringify([this.selectedWave]);

        $.ajax({
          method: "POST",
          url: queryString,
          data: data,
          dataType: "json",
          contentType: "application/json; charset=utf-8",
          success: (data) => {
            if (data.Error) {
              console.error(data.Error);
              this.globals.showErrorSnackbar(data.Error);
              return;
            }
            if (data[0]) {
              if (data[0].WaveId) this.selectedWave.WaveId = data[0].WaveId;
              if (data[0].WaveGuid)
                this.selectedWave.WaveGuid = data[0].WaveGuid;
              if (data[0].WavePosition)
                this.selectedWave.WavePosition = data[0].WavePosition;
            }
            if (!this.selectedWave.CompetitorCarModelDistribution)
              this.selectedWave.CompetitorCarModelDistribution = [];
            let wave = _.cloneDeep(this.selectedWave);
            this.waves.push(wave);
            this.doFilteringWaves();
            this.$forceUpdate();
            this.globals.showSuccessSnackbar("Wave update successful");
            this.selectedWaveDirty = false;
          },
          error: () => {
            console.error("Error on POST in saveSelectedWave()");
            this.globals.showErrorSnackbar("Wave update failed");
          },
        });
      }
    },

    saveWavePositions() {
      let queryString = `api/Projects/${this.selectedProjectData.ProjectGuid}/Waves`;

      this.readWavePositions();
      let data = JSON.stringify(this.wavePositions);

      $.ajax({
        method: "PUT",
        url: queryString,
        data: data,
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: (data) => {
          if (data.Error) {
            console.error(data.Error);
            this.globals.showErrorSnackbar(data.Error);
            return;
          }
          this.globals.showSuccessSnackbar("Wave position update successful");
          this.wavePositionsDirty = false;
        },
        error: () => {
          console.error("Error on PUT in saveWavePositions()");
          this.globals.showErrorSnackbar("Wave position update failed");
        },
      });
    },

    deleteSelectedWave() {
      $.ajax({
        method: "DELETE",
        url: "api/ProjectWaves/" + this.selectedWave.WaveGuid,
        success: (data) => {
          if (data.Error) {
            console.error(data.Error);
            this.globals.showErrorSnackbar(data.Error);
            return;
          }
          // If delete was successful, refresh displayed data and hide dialog
          this.globals.showSuccessSnackbar("Wave deletion successful");
          _.remove(this.waves, (w) => {
            return w.WaveGuid === this.selectedWave.WaveGuid;
          });
          this.createNewWave();
          this.closeWavePositionGap();
          this.doFilteringWaves();
        },
        error: () => {
          console.error("Wave deletion failed in deleteSelectedWave()");
          this.globals.showErrorSnackbar("Wave deletion failed");
        },
      });
    },

    createNewWave() {
      this.selectedWave = {
        WaveGuid: uuidv4(),
        ReportingVisibility: true,
        Scenarios: [],
      };
      this.fpInputWaveUntil.clear();
      this.fpInputWaveSince.clear();
      this.clearCarModelDistribution();
      if (
        this.feature.isAudiTarget &&
        this.feature.isEnabled("shopperApproval")
      )
        this.selectedWave.CompetitorCarModelDistribution = [];
      this.selectedWaveDirty = false;
    },

    getAllWaves() {
      let queryString = `api/Projects/${this.selectedProjectData.ProjectGuid}/Waves`;
      $.ajax({
        method: "GET",
        url: queryString,
        success: (data) => {
          if (!data || _.isEmpty(data)) {
            this.waves = [];
            return;
          }
          this.waves = data;
          this.sortWavesByPosition();
          this.doFilteringWaves();
        },
        error: () => {
          console.error("Error on GET in getAllWaves()");
          this.globals.showErrorSnackbar("Wave request failed");
        },
      });
    },

    getAllScenarios() {
      let queryString = "api/Scenarios";
      $.ajax({
        method: "GET",
        url: queryString,
        success: (data) => {
          this.scenarios = data;
          this.getScenariosOfClient();
        },
        error: () => {
          console.error("Error on GET in getAllScenarios()");
          this.globals.showErrorSnackbar("Scenario request failed");
        },
      });
    },

    getScenariosOfClient() {
      let queryString = `/api/Clients/${this.selectedClient}/Scenarios`;
      $.ajax({
        method: "GET",
        url: queryString,
        success: (data) => {
          this.scenarios = this.scenarios.filter((sc) => {
            return _.indexOf(data.Scenarios, sc.ScenarioGuid) < 0
              ? false
              : true;
          });
          this.doFilteringScenarios();
        },
        error: () => {
          console.error("Error on GET in getScenariosOfClient()");
          this.globals.showErrorSnackbar("Scenario request failed");
        },
      });
    },

    doFilteringWaves() {
      // Reset filtering when search string is empty
      if (!this.waves || this.waves.length < 1) return;
      if (!this.filterWaveString) {
        this.filteredWaves = this.waves;
        return;
      }

      let words = this.filterWaveString.split(" ");
      let keys = ["WaveId", "WaveName", "WaveStart", "WaveEnd"];

      const waveFilter = (wave) => {
        let containsSearch = false;
        words.forEach((word) => {
          keys.forEach((key) => {
            if (
              wave[key] &&
              wave[key].toString().toLowerCase().indexOf(word.toLowerCase()) >
                -1
            ) {
              containsSearch = true;
              return;
            }
          });
        });
        return containsSearch;
      };
      this.filteredWaves = this.waves.filter(waveFilter);
    },

    reorderWaves() {
      let allPositions = _.range(1, this.waves.length + 1);
      let missingPos = 0;
      let newPos = 0;
      let waveGuid = "";

      // Find missing position number and the position and name of the changed wave
      for (var i = 0; i < allPositions.length; i++) {
        if (this.waves[i].WavePosition != allPositions[i]) {
          missingPos = allPositions[i];
          newPos = this.waves[i].WavePosition;
          waveGuid = this.waves[i].WaveGuid;
        }
      }
      if (missingPos == 0) return; // No position missing -> no value changed

      // Move position numbers between new position number and missing position number
      for (var i = 0; i < allPositions.length; i++) {
        if (this.waves[i].WaveGuid != waveGuid) {
          // Do NOT move the changed wave
          if (
            this.waves[i].WavePosition < missingPos &&
            this.waves[i].WavePosition >= newPos
          ) {
            this.waves[i].WavePosition++;
          }
          if (
            this.waves[i].WavePosition > missingPos &&
            this.waves[i].WavePosition <= newPos
          ) {
            this.waves[i].WavePosition--;
          }
        }
      }
      this.sortWavesByPosition();
      this.$forceUpdate(); // Forces the table to update
    },

    closeWavePositionGap() {
      if (this.waves.length < 1) return;
      this.waves[0].WavePosition = 1;
      for (let i = 1; i < this.waves.length; i++) {
        // Closes gap
        if (this.waves[i].WavePosition > this.waves[i - 1].WavePosition + 1)
          this.waves[i].WavePosition--;
        // Fixes double wave positions
        if (this.waves[i].WavePosition == this.waves[i - 1].WavePosition)
          this.waves[i].WavePosition++;
      }
    },

    sortWavesByPosition() {
      if (!this.waves) return;
      this.waves.sort((a, b) => {
        return a.WavePosition - b.WavePosition;
      });
    },

    readWavePositions() {
      this.wavePositions = [];
      for (let wave of this.waves) {
        this.wavePositions.push({
          WaveGuid: wave.WaveGuid,
          WavePosition: wave.WavePosition,
        });
      }
    },

    doFilteringScenarios() {
      // Reset filtering when search string is empty
      if (!this.scenarios || this.scenarios.length < 1) return;
      if (!this.filterScenarioString) {
        this.filteredScenarios = this.scenarios;
        return;
      }

      let words = this.filterScenarioString.split(" ");
      let keys = ["ScenarioId", "ScenarioName", "ScenarioDescription"];

      const scenarioFilter = (scenario) => {
        let containsSearch = false;
        words.forEach((word) => {
          keys.forEach((key) => {
            if (
              scenario[key] &&
              scenario[key]
                .toString()
                .toLowerCase()
                .indexOf(word.toLowerCase()) > -1
            ) {
              containsSearch = true;
              return;
            }
          });
        });
        return containsSearch;
      };
      this.filteredScenarios = this.scenarios.filter(scenarioFilter);
    },

    selectWave(WaveGuid) {
      let wave = this.waves.find((w) => {
        return w.WaveGuid === WaveGuid;
      });
      if (wave) {
        this.selectedWave = _.cloneDeep(wave);
        if (this.carModelList.length > 0)
          this.readCarModelDistributionFromSelectedWave();
        if (
          this.feature.isAudiTarget &&
          this.feature.isEnabled("shopperApproval") &&
          !this.selectedWave.CompetitorCarModelDistribution
        )
          this.selectedWave.CompetitorCarModelDistribution = [];
        this.fpInputWaveSince.setDate(this.selectedWave.WaveSince);
        this.fpInputWaveUntil.setDate(this.selectedWave.WaveUntil);
        this.selectedWaveDirty = false;
      } else this.createNewWave();
    },

    isWaveSelected(WaveGuid) {
      return this.selectedWave.WaveGuid === WaveGuid;
    },

    selectScenario(scenarioGuid) {
      if (!this.selectedWave.WaveId) return;
      if (!this.selectedWave.Scenarios)
        this.selectedWave.Scenarios = [scenarioGuid];
      else {
        let idx = _.indexOf(this.selectedWave.Scenarios, scenarioGuid);
        if (idx > -1) {
          _.pullAt(this.selectedWave.Scenarios, idx);
        } else {
          this.selectedWave.Scenarios.push(scenarioGuid);
        }
      }
      this.selectedWaveDirty = true;
      this.$forceUpdate();
    },

    isScenarioSelected(scenarioGuid) {
      return _.indexOf(this.selectedWave.Scenarios, scenarioGuid) > -1;
    },

    openDeleteWaveConfirmationDialog() {
      this.globals.$emit(
        "openGlobalConfirmationDialog",
        this.getDeleteDialogData()
      );
    },

    getDeleteDialogData() {
      return {
        initiator: "WaveDeleteModal",
        confirmationTitle: this.lang.WV0018,
        colorRed: true,
        yesButtonText: this.lang.WV0016,
        noButtonText: this.lang.WV0017,
        htmlText: `<p><b>${this.lang.WV0019}</b></p>
        <div class="form-group">
          <label class="col-md-3 text-black">${this.lang.WV0002}</label>
          <label class="col-md-9 text-black">${this.selectedWave.WaveId}</label>
        </div>
        <div class="form-group">
          <label class="col-md-3 text-black">${this.lang.WV0003}</label>
          <label class="col-md-9 text-black">${
            this.selectedWave.WaveName
          }</label>
        </div>
        <div class="form-group">
          <label class="col-md-3 text-black">${this.lang.WV0020}</label>
          <label class="col-md-9 text-black">${this.globals.getLocalizedDateFromIsoTimestamp(
            this.selectedWave.WaveSince
          )} - ${this.globals.getLocalizedDateFromIsoTimestamp(
          this.selectedWave.WaveUntil
        )}</label>
        </div>`,
      };
    },

    openWaveEditDialog() {
      this.wavePositionsDirty = false;
      this.filteredWaves = [];
      this.createNewWave();
      this.getAllWaves();
      this.getAllScenarios();
      UseSurvey.getAll(
        {
          ProjectGuid: this.selectedProjectData.ProjectGuid,
        },
        null // set page_size null to get unlimited page_size
      ).then(({ data }) => {
        this.surveyList = data[0].Surveys;
      });
      $("#editWaveDialog").modal("show");
    },

    closeWaveEditDialog() {
      $("#editWaveDialog").modal("hide");
    },

    waveReportingVisibilityChanged(wave) {
      if (wave.ReportingVisibility === false) return;
      let forceReportingVisibilityChange = false;

      this.globals.$off("WaveReportingVisibilityChangedModalYesConfirmation");
      this.globals.$on(
        "WaveReportingVisibilityChangedModalYesConfirmation",
        () => {
          wave.ReportingVisibility = true;
          forceReportingVisibilityChange = true;
        }
      );
      this.globals.$off("WaveReportingVisibilityChangedModalDialogClosed");
      this.globals.$on(
        "WaveReportingVisibilityChangedModalDialogClosed",
        () => {
          if (!forceReportingVisibilityChange) wave.ReportingVisibility = false;
          forceReportingVisibilityChange = false;
        }
      );
      this.openReportingVisibilityChangedDialog();
    },

    openReportingVisibilityChangedDialog() {
      this.globals.$emit(
        "openGlobalConfirmationDialog",
        this.getReportingVisibilityChangedDialogData()
      );
    },

    getReportingVisibilityChangedDialogData() {
      return {
        initiator: "WaveReportingVisibilityChangedModal",
        confirmationTitle: this.lang.WV0021,
        colorRed: true,
        yesButtonText: this.lang.WV0016,
        noButtonText: this.lang.WV0017,
        htmlText: `<p><b>${this.lang.WV0022}</b></p>
        <p>${this.lang.WV0023}</p>`,
      };
    },
  },
};
</script>

<style scoped>
.modal-lg {
  width: calc(100vw - 300px);
}

.table-container {
  height: calc(100vh - 355px);
  overflow-y: auto;
}
.table-waves {
  height: calc(100vh - 300px);
}

.modal-content {
  background-color: #eee;
}

#editWaveDialog .panel-body {
  padding: 0 !important;
}

.modal-footer .btn-default {
  background: rgb(190, 190, 190);
}

.btn-top-bar.btn.btn-raised.btn-success:not(:disabled) {
  background-color: #4caf50;
}
.btn.btn-raised.btn-success:hover:not(:disabled) {
  background-color: #59b75c;
}
.btn-top-bar.btn.btn-raised.btn-warning:not(:disabled) {
  background-color: #ff5722;
}
.btn.btn-raised.btn-warning:hover:not(:disabled) {
  background-color: #ec5122ab;
}

/* Tabs for wave edit mode */
.nav-wave-edit {
  background-color: var(--color-primary);
  padding: 0px;
}
.nav-wave-edit > li {
  text-align: center;
  float: none;
  display: inline-block;
}
.nav-wave-edit > li.active {
  background-color: rgba(255, 255, 255, 0.1);
}
.nav-wave-edit > li.active > a {
  font-weight: bold;
}

.form-group {
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// WaveEditModal.vue?35eb7080